
function createCallbackName() {
  const callbackName = `cb${Date.now()}`;
  if (window[callbackName]) return createCallbackName();
  return callbackName
}

const TIME_UNTIL_CALLBACK_IS_DELETED_AFTER_FINISH = 60e3;
export class ScriptRequest {
  constructor({ url, params = {}, callbackName, onSuccess = () => {}, onError = () => {} }) {
    this.callbackName = callbackName || createCallbackName();
    this.url = this._updateUrl(url, params);
    this.onSuccess = onSuccess;
    this.onError = onError;
    this.isFinished = false;
    this.script = undefined;

    this._send(url);
  }

  abort = () => this._endWork();

  _send = () => {
    window[this.callbackName] = this._onSuccess;
    this.script = document.createElement('script');
    this._createErrorCatchers();
    this.script.src = this.url;
    document.body.appendChild(this.script);
  }

  _updateUrl = (url, params) => {
    let newUrl = `${url}${~url.indexOf('?') ? '&' : '?'}`;

    /* addParamsToURL */
    let uriParams = [];
    for (let param in params) {
      if (params[param]) {
        uriParams.push(`${encodeURIComponent(param)}=${encodeURIComponent(params[param])}&`);
      }
    }
    newUrl += uriParams.join();

    /* addCallbackToUrl */
    newUrl += `callback=${this.callbackName}`;

    return newUrl
  }

  _onSuccess = response => {
    if (this.isFinished) return;
    this._endWork();
    this.onSuccess(response);
  }

  _createErrorCatchers = () => {
    this.script.onload = this._checkCallback;
    this.script.onerror = this._checkCallback;
    /* for IE */
    this.script.onreadystatechange = () => {
      if (this.readyState === 'complete' || this.readyState === 'loaded') {
        this.script.onreadystatechange = null;
        setTimeout(this._checkCallback, 0);
      }
    }
  }

  _checkCallback = () => {
    if (this.isFinished) return;
    this._endWork();
    this.onError(this.url);
  }

  _endWork = () => {
    this.isFinished = true;
    setTimeout(() => {
      delete window[this.callbackName];
    }, TIME_UNTIL_CALLBACK_IS_DELETED_AFTER_FINISH)
    document.body.appendChild(this.script);
  }
}

export class ScriptRequests {
  constructor() {
    this.requests = {};
  }

  send = ({ url, params, callbackName, onSuccess, onError }) => {
    const requestKey = callbackName || createCallbackName();
    this.requests[requestKey] = new ScriptRequest({
      url,
      params,
      callbackName,
      onSuccess: event => {
        delete this.requests[requestKey];
        onSuccess(event);
      },
      onError: event => {
        delete this.requests[requestKey];
        onError(event);
      },
    });
  }

  abort = () => {
    Object.keys(this.requests).forEach(requestKey => {
      this.requests[requestKey].abort();
      delete this.requests[requestKey];
    });
  }
}
